module.exports = __webpack_public_path__ + "static/09-14843ab446ac67ca732566a6c37de64a.jpg";